import { Injectable, computed, inject, signal } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { NotificationService } from 'src/app/core/services/notification.service';
import { SupportChatService } from './support-chat.service';

/**
 * Opens the support chat-box from anywhere ("Need help?", "Contact us"),
 * optionally with a message already typed in the composer.
 */
@Injectable({ providedIn: 'root' })
export class SupportChatLauncherService {
  private chat = inject(SupportChatService);
  private notificationService = inject(NotificationService);

  private readonly requests = new Subject<string>();
  /** For the chat-box: open requests, with the text to prefill ('' for none). */
  readonly requests$: Observable<string> = this.requests.asObservable();
  /** Chat-boxes on screen (the sidenav's, or a full-screen page's own). */
  private readonly mounted = signal(0);
  /** A chat-box is on screen and the user is a client (team members use the inbox). */
  readonly available = computed(() => !!this.mounted() && this.chat.available());

  attach(): void {
    this.mounted.update((n) => n + 1);
  }

  detach(): void {
    this.mounted.update((n) => Math.max(0, n - 1));
  }

  /** Opens the chat with `message` in the composer; says so if it can't. */
  open(message = ''): boolean {
    if (!this.available()) {
      this.notificationService.warn(
        "Our chat couldn't open right now. Please try again in a moment.",
      );
      return false;
    }
    this.requests.next(message);
    return true;
  }
}
